import { render, staticRenderFns } from "./_BaseLink.vue?vue&type=template&id=38da9d2a&"
import script from "./_BaseLink.vue?vue&type=script&lang=js&"
export * from "./_BaseLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports